import React from 'react'

export const Loader = () => {
  return (
        <div className="loader-overlay">
            <div className="loader-spinner"></div>
        </div>
  )
}
